import { MOBILE_OS } from "~/constants/mobile-os";
import { BrowserAPI } from "~/utils/browser";

/**
 * Detect mobile operating system
 *
 * @returns Mobile OS type (Android, iOS, or Other)
 * @example
 * ```typescript
 * const os = getMobileOS();
 * if (os === MOBILE_OS.IOS) {
 *   // iOS-specific logic
 * }
 * ```
 */
export const getMobileOS = () => {
  if (BrowserAPI.isServer()) {
    return MOBILE_OS.OTHER;
  }

  const ua = BrowserAPI.navigator.userAgent;

  if (/android/i.test(ua))
    return MOBILE_OS.ANDROID;

  const windowInstance = BrowserAPI.window.instance;
  if (/iPad|iPhone|iPod/.test(ua) && windowInstance && !(windowInstance as any).MSStream)
    return MOBILE_OS.IOS;

  return MOBILE_OS.OTHER;
};
